export default "__VITE_ASSET__16ea2eb2__"